module.exports = __webpack_public_path__ + "img/crown.0a51e492.png";